import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/connections')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/integrations' });
  },
});
